import React from 'react';
import RadioButton from '../RadioButton';
import CustomFeedback from '../CustomFeedback';
import QuestionDependency from '../QuestionDependency';
import OptionalImage from '../../lessonPlayer/components/OptionalImage';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const DependentMultiChoice = ({ model, isManuscriptShort }) => {
  const correctSet = model.validation?.answerSets?.[0] ?? [];

  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Question Type:</div>
        <div>Dependent Multi Choice</div>
      </div>
      <div className='label-value-row'>
        <div>Question Number:</div>
        <div>{model.questionNumber}</div>
      </div>
      <div className='label-value-row'>
        <div>Point Value:</div>
        <div>{model.maxScore}</div>
      </div>
      <OptionalImage model={model} />
      {(model.questions || []).map((question, qIdx) => {
        const correctAnswerId = correctSet[qIdx] ?? null;
        return (
          <div key={question.id}>
            <div className='label-value-row'>
              <div className='text-area-label'>Question {qIdx + 1}:</div>
              <div className='ckeditor-text text-area'><HtmlComponent htmlStr={question.questionText} /></div>
            </div>
            <div className='choices'>
              <div>Choices:</div>
              <div>Correct</div>
              {(question.answers || []).map((answer, idx) => {
                const selected = answer.id === correctAnswerId;
                const answerLetter = String.fromCharCode(65 + idx);
                return (
                  <React.Fragment key={answer.id}>
                    <div className='choice-letter'>{`${answerLetter}:`}</div>
                    <div className='ckeditor-text text-area'><HtmlComponent htmlStr={answer.text} /></div>
                    <div className='correct-button'>
                      <RadioButton selected={selected} />
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        );
      })}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Auto-scored:</div>
            <div>{model.autoScore?.toString() ?? 'true'}</div>
          </div>
        </>
      )}
      <CustomFeedback model={model} />
      <div className='label-value-row'>
        <div>Hint:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.hint} /></div>
      </div>
      <div className='label-value-row'>
        <div>Solution:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.validation?.solution} /></div>
      </div>
    </div>
  );
};

export default DependentMultiChoice;
